module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/coupons/coupons/coupons-list/coupons-list.component.scss
// module id = ./src/app/coupons/coupons/coupons-list/coupons-list.component.scss
// module chunks = main